import { useState, useEffect } from 'react';

import { Image } from 'antd';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';

import { getJlcWebsiteGroup } from '../header-http';

import Utils from '@lcsc-ui/utils/Utils';

const GroupSitesPop = () => {
  // 使用 state 来存储数据
  const [groupSites, setGroupSites] = useState(null);
  const [fetchingSites, setFetchingSites] = useState(false);
  const [jlcGroup_source, set_jlcGroup_source] = useState();
  const [saveCode, setSaveCode] = useState();
  const router = useRouter();

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    set_jlcGroup_source(router?.query?.jlcGroup_source || Cookies.get('jlcGroup_source'));
  }, [router?.query?.jlcGroup_source]);

  useEffect(() => {
    setSaveCode(router?.query?.c || Cookies.get('cookies_save_operation_code_mark'));
  }, [router?.query?.c]);

  async function getData() {
    setFetchingSites(true);
    try {
      const { result } = await getJlcWebsiteGroup();
      setGroupSites(result);
    } catch (error) {
      // ...
    }
  }

  const sitegroupTypeNames = {
    1: '电子产业',
    2: '机械产业',
    3: '工业软件',
    4: '更多服务',
  };

  const sm = [];

  (groupSites || []).forEach((t) => {
    if (!sm[t.industryType]) {
      sm[t.industryType] = [t];
    } else {
      sm[t.industryType] = [...sm[t.industryType], t];
    }
  });

  const sitegroupObj = sm.filter(Boolean);
  return (
    <ul className="px-[8px] py-[4px] flex">
      {sitegroupObj.length ? (
        sitegroupObj.map((data, idx) => {
          const lastClassNames =
            idx === sitegroupObj.length - 1
              ? 'pr-0 h-max pl-[16px] min-w-[180px] border-l-[#eee] border-l-[1px] border-solid'
              : '';
          const lastTwoClassNames =
            idx === sitegroupObj.length - 2 ? 'pr-[16px] min-w-[180px]' : 'min-w-[250px] pr-[32px]';
          return (
            <li key={idx} className={`flex flex-col ${lastClassNames} ${lastTwoClassNames}`}>
              <span className="text-[#262626] font-bold pb-[10px] text-[14px] border-b-[1px] border-solid border-[#eee] leading-[20px]">
                {sitegroupTypeNames[data[0].industryType]}
              </span>
              <ul className="flex flex-col">
                {data.map((site, idx) => (
                  <a
                    className="flex items-center mt-[20px]"
                    href={Utils.groupJumpUrl(site.link, jlcGroup_source, saveCode)}
                    key={idx}
                    target="_blank"
                    title={site.title}
                  >
                    {!!site.icon && (
                      <Image
                        className={`mr-[8px]`}
                        width={36}
                        height={36}
                        src={site.icon}
                        alt={site.title}
                        preview={false}
                        fallback="https://static.szlcsc.com/ecp/assets/newWeb/item/default_pic.gif"
                      />
                    )}
                    <section className="ml-[10px]">
                      <p className="flex items-center">
                        <span className="text-[14px] leading-[20px] mr-[3px]">{site.title}</span>
                        {site.newFlag ? (
                          <Image
                            width={26}
                            height={13}
                            src="//static.szlcsc.com/ecp/assets/web/layout/jlcSiteGroup/new.png"
                            alt="new"
                            preview={false}
                            fallback="https://static.szlcsc.com/ecp/assets/newWeb/item/default_pic.gif"
                          ></Image>
                        ) : undefined}
                      </p>
                      <p className="text-[12px] text-[#8c8c8c] leading-[20px] mb-0 mt-[2px] w-[180px] whitespace-pre-wrap">
                        {site.description}
                      </p>
                    </section>
                  </a>
                ))}
              </ul>
            </li>
          );
        })
      ) : fetchingSites ? (
        <p className="mx-auto">加载中...</p>
      ) : (
        <p className="mx-auto">暂无配置</p>
      )}
    </ul>
  );
};

export default GroupSitesPop;
